export default [
    {
        path: '/payment',
        name: 'payment',
        component: () => import('@/views/payment/TariffsView.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/tariffs',
        name: 'tariffs',
        component: () => import('@/views/payment/TariffsAdminView.vue'),
        meta: {
            requiresAuth: true
        }
    }
]
